var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.219482,
    y: 0.609741,
    width: 26.7805,
    height: 26.7805,
    rx: 7.43902,
    fill: "#F1F2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3048 7.30481L6.91455 20.6951M6.91455 7.30481L20.3048 20.6951",
    stroke: "black",
    strokeWidth: 2.97561,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXClose);
export default __webpack_public_path__ + "static/media/x-close.4630e2ac4d1462aeccfd306b60587095.svg";
export { ForwardRef as ReactComponent };